import { AuthScreen, Card } from '@dss/design-system'
import { Link } from '../../lib/router'
import { useDistributorBrand } from '../../lib/distributor-brand'
import { KeycloakLoginButton } from './KeycloakLoginButton'

/** Пароль вводится только на настоящей странице службы входа. */
export function LoginScreen() {
  const { current: brand } = useDistributorBrand()
  return <AuthScreen brand={brand ?? undefined}>
    <Card padding="lg">
      <h1>Вход в портал</h1>
      <p>Откройте страницу входа и введите электронную почту и пароль,
        которые вы указали при принятии приглашения.</p>
      <KeycloakLoginButton />
      <p><Link to="/forgot-password">Забыли пароль?</Link></p>
    </Card>
    <p>Нет доступа? Обратитесь к тому, кто пригласил вас в портал.
      Самостоятельной регистрации здесь нет.</p>
  </AuthScreen>
}
